import { FormModal } from "../../../../_components/Forms/FormModal";
import { WeighbridgeTicketsFormProvider } from "./WeighbridgeTicketsFormProvider";
import { DomainButton } from "../../../../_components/Abstractions/DomainButton";
import { BadgeDomain } from "../../../../_components/Abstractions/BadgeDomain";
import { ModalDomain } from "../../../../_components/Abstractions/ModalDomain";
import { FormDomain } from "../../../../_components/Forms/FormDomain";
import { WeighbridgeTicketsFormControls } from "./WeighbridgeTicketsFormControls";

export function WeighbridgeTicketsToOrderForm({ order, onSubmit, onShowModal, loading, show, onOpenClick, onCloseModal, weighbridgeTicketsCount: externalCount, setProtocolCompleted }) {
  const { formControls, defaultValues, validationSchema } = WeighbridgeTicketsFormProvider({
    order,
    formControls: <WeighbridgeTicketsFormControls />,
    setProtocolCompleted
  });
  const count = externalCount ?? order?.wastesDetails?.weighbridgeTickets?.length;
  const buttonText = <>Kwity wagowe {count > 0 && <BadgeDomain>{count}</BadgeDomain>}</>;

  // Controlled mode (with pre-fetch) - used in management view
  if (onOpenClick !== undefined) {
    return (
      <>
        <DomainButton size="x-small" onClick={onOpenClick} disabled={loading}>
          {loading ? "Kwity wagowe" : "Kwity wagowe"}
        </DomainButton>
        {show && (
          <ModalDomain
            title="Kwity wagowe"
            buttonText={null}
            show={show}
            handleShow={null}
            handleClose={onCloseModal}
            size="lg"
            isButtonTrigger={false}
            body={
              <FormDomain
                formControls={formControls}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                successMessage="Zaktualizowano kwity wagowe"
                isModal={true}
                handleModal={onCloseModal}
                defaultValues={defaultValues}
              />
            }
          />
        )}
      </>
    );
  }

  return (
    <FormModal
      formControls={formControls}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      onShowModal={onShowModal}
      loading={loading}
      buttonText={buttonText}
      successMessage="Zapisano kwity wagowe"
      title="Kwity wagowe"
      btnSize="x-small"
      sizeModal="lg"
    />
  );
}
